import React from "react";

export function ProfileIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 61 61"
      width="30"
      height="30"
      {...props}
    >
      <path
        className="cls-1"
        d="m44.36,48.94l-1.27-.03c0-.07.12-6.83-1.39-9.5-1.27-2.12-3.36-3.08-5.43-3.8-.57-.2-1.15-.38-1.73-.56-2.05-.65-4.17-1.31-5.83-2.67-3.73-3.04-6.14-7.53-6.14-11.45,0-5.05,3.61-9.16,8.04-9.16s8.04,4.11,8.04,9.16c0,2.26-.73,4.44-2.06,6.12l-1.21,1.6-1.01-.77,1.22-1.61c1.16-1.47,1.79-3.36,1.79-5.34,0-4.35-3.04-7.89-6.77-7.89s-6.77,3.54-6.77,7.89c0,3.55,2.23,7.66,5.67,10.46,1.48,1.2,3.39,1.8,5.41,2.44.59.19,1.18.37,1.76.57,2.3.8,4.63,1.88,6.11,4.37,1.69,2.99,1.57,9.87,1.56,10.16Z"
      />
      <path
        className="cls-1"
        d="m17.58,48.93h-1.27c0-1.05-.04-1.97-.08-2.81-.11-2.52-.19-4.35.98-6.53,1.23-2.3,3.03-3.51,4.77-4.68,1.02-.68,2.07-1.39,2.99-2.31l.9.9c-1.01,1.01-2.11,1.75-3.17,2.47-1.69,1.14-3.28,2.21-4.36,4.23-1.01,1.88-.93,3.47-.83,5.88.04.85.08,1.79.08,2.86Z"
      />
      <path
        className="cls-1"
        d="m30.5,61C13.68,61,0,47.32,0,30.5S13.68,0,30.5,0s30.5,13.68,30.5,30.5-13.68,30.5-30.5,30.5Zm0-58.46C15.08,2.54,2.54,15.08,2.54,30.5s12.54,27.96,27.96,27.96,27.96-12.54,27.96-27.96S45.92,2.54,30.5,2.54Z"
      />
    </svg>
  );
}
